import './main-product.css'

export default class MainProduct extends HTMLElement {
  connectedCallback() {
    this.handleNoReviews();
  }

  handleNoReviews() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                document.querySelectorAll('.pr-snippet-review-count').forEach((element) => {
                    if (element.textContent.trim() === 'No Reviews') {
                        element.setAttribute('data-no-reviews', 'true');
                    }
                });
            }
        });
    });

    const targetNode = document.getElementById('pr-reviewsnippet');
    if (targetNode) {
        observer.observe(targetNode, {
            childList: true,
            subtree: true
        });
    }
  }
}

export const webcomponent = 'main-product';
